import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import * as authAPI from 'lib/api/auth';
import { changeField } from 'modules/authSlice';
import client, { serviceClient } from 'lib/api/client';
import { useEffect } from 'react';

const useLoginCheck = (error, refetch) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      error?.status === 401 ||
      error?.data.error === 'AuthorizationNotFound'
    ) {
      (async () => {
        try {
          const refreshToken = localStorage.getItem('refreshToken');
          const username = localStorage.getItem('username');
          const userLevel = localStorage.getItem('userLevel');
          const userType = localStorage.getItem('userType');

          const {
            data: { access_token },
          } = await authAPI.loginCheck(refreshToken);

          dispatch(changeField({ key: 'accessToken', value: access_token }));
          dispatch(changeField({ key: 'username', value: username }));
          dispatch(changeField({ key: 'userLevel', value: userLevel }));
          dispatch(changeField({ key: 'userType', value: userType }));

          client.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${access_token}`;

          serviceClient.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${access_token}`;

          refetch();
        } catch (_) {
          localStorage.clear();
          navigate('/');
        }
      })();
    }
  }, [dispatch, error, location.pathname, navigate, refetch]);
};

export default useLoginCheck;
